import { c as _c } from "react/compiler-runtime";
import { Divider, MenuItem, Select, Stack, Typography, type SelectChangeEvent } from '@mui/material';
import type { BackupPolicyType, Condition, Provider, ResourceType } from '@repo/api-gw-sdk';
import { ConditionEditor } from '@/components/conditions/ConditionEditor';
import { isEmptyCondition, type FilterProperty } from '@/types/advanceFilter';
import type { ResourcesScopeType } from './resourceSelectionDynamicViewer';
import { DynamicResourcesAllExcluded, DynamicResourcesAllIncluded } from '../../app/(dashboard)/settings/backup-policies/backup-scopes/[tab]/dynamicResourcesEmptyState';
export const ResourceSelectionDynamicEditor = t0 => {
  const $ = _c(34);
  const {
    condition,
    setCondition,
    supportedProviders,
    supportedProperties,
    supportedResourceTypes,
    conditionTitle,
    allExcludedDescription,
    allIncludedDescription,
    resourcesScopeType,
    setResourcesScopeType,
    selectedResourceTypes,
    policyType
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      gap: "24px",
      width: "100%",
      flexGrow: 1,
      minHeight: 0,
      overflow: "auto"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  let t3;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      justifyContent: "space-between",
      alignItems: "center"
    };
    t3 = <Typography variant="h3">Dynamic resource selection</Typography>;
    $[1] = t2;
    $[2] = t3;
  } else {
    t2 = $[1];
    t3 = $[2];
  }
  let t4;
  let t5;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      justifyContent: "space-between",
      alignItems: "center",
      gap: "8px"
    };
    t5 = <Typography variant="subtitle1">Selection method</Typography>;
    $[3] = t4;
    $[4] = t5;
  } else {
    t4 = $[3];
    t5 = $[4];
  }
  let t6;
  if ($[5] !== setResourcesScopeType) {
    t6 = e => setResourcesScopeType(e.target.value as ResourcesScopeType);
    $[5] = setResourcesScopeType;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  let t8;
  let t9;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <MenuItem key="all_included" value="allIncluded" data-testid="include-all-option">Include all</MenuItem>;
    t8 = <MenuItem key="use_conditions" value="useConditions" data-testid="use-conditions-option">Use conditions</MenuItem>;
    t9 = <MenuItem key="all_excluded" value="allExcluded" data-testid="exclude-all-option">Exclude all</MenuItem>;
    $[7] = t7;
    $[8] = t8;
    $[9] = t9;
  } else {
    t7 = $[7];
    t8 = $[8];
    t9 = $[9];
  }
  let t10;
  if ($[10] !== resourcesScopeType || $[11] !== t6) {
    t10 = <Stack direction="row" sx={t2}>{t3}<Stack direction="row" sx={t4}>{t5}<Select data-testid="resource-selection-method-select" variant="standard" value={resourcesScopeType} onChange={t6}>{t7}{t8}{t9}</Select></Stack></Stack>;
    $[10] = resourcesScopeType;
    $[11] = t6;
    $[12] = t10;
  } else {
    t10 = $[12];
  }
  let t11;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <Divider />;
    $[13] = t11;
  } else {
    t11 = $[13];
  }
  const t12 = resourcesScopeType === "useConditions" ? "flex-start" : "center";
  let t13;
  if ($[14] !== t12) {
    t13 = {
      marginTop: "16px",
      width: "100%",
      flexGrow: 1,
      minHeight: 0,
      justifyContent: t12
    };
    $[14] = t12;
    $[15] = t13;
  } else {
    t13 = $[15];
  }
  let t14;
  if ($[16] !== allExcludedDescription || $[17] !== allIncludedDescription || $[18] !== condition || $[19] !== conditionTitle || $[20] !== policyType || $[21] !== resourcesScopeType || $[22] !== selectedResourceTypes || $[23] !== setCondition || $[24] !== supportedProperties || $[25] !== supportedProviders || $[26] !== supportedResourceTypes) {
    t14 = resourcesScopeType === "useConditions" ? <Stack sx={{
      gap: "24px"
    }}>{typeof conditionTitle === "string" ? <Typography variant="subtitle1">{conditionTitle}</Typography> : conditionTitle}<ConditionEditor options={{
        supportGrouping: true,
        supportedProperties
      }} condition={!condition || isEmptyCondition(condition) ? undefined : condition} onChange={setCondition} supportedProviders={supportedProviders} supportedResourceTypes={supportedResourceTypes} /></Stack> : resourcesScopeType === "allExcluded" ? <DynamicResourcesAllExcluded description={allExcludedDescription} /> : <DynamicResourcesAllIncluded selectedResourceTypes={selectedResourceTypes} policyType={policyType} description={allIncludedDescription} />;
    $[16] = allExcludedDescription;
    $[17] = allIncludedDescription;
    $[18] = condition;
    $[19] = conditionTitle;
    $[20] = policyType;
    $[21] = resourcesScopeType;
    $[22] = selectedResourceTypes;
    $[23] = setCondition;
    $[24] = supportedProperties;
    $[25] = supportedProviders;
    $[26] = supportedResourceTypes;
    $[27] = t14;
  } else {
    t14 = $[27];
  }
  let t15;
  if ($[28] !== t13 || $[29] !== t14) {
    t15 = <Stack sx={t13}>{t14}</Stack>;
    $[28] = t13;
    $[29] = t14;
    $[30] = t15;
  } else {
    t15 = $[30];
  }
  let t16;
  if ($[31] !== t10 || $[32] !== t15) {
    t16 = <Stack sx={t1}>{t10}{t11}{t15}</Stack>;
    $[31] = t10;
    $[32] = t15;
    $[33] = t16;
  } else {
    t16 = $[33];
  }
  return t16;
};